module.exports = __webpack_public_path__ + "static/don27-558bb37912a5134a233cb3d174b1385b.jpg";